
  import { Vue, Component, Prop,  } from "vue-property-decorator";
  import UiButton from "@/components/button/ui-button.vue";
  import GroupModal from "@/components/teams/GroupModal.vue";
  import PlusIcon from "@/components/icons/PlusIcon.vue";
  import { User } from "@/generated/graphql";


  @Component({
    components: {
      UiButton,
      GroupModal,
      PlusIcon,
    },
  })
  export default class GroupModalWithButton extends Vue {
    @Prop({type: String, required: true}) readonly companyId!: string;
    @Prop({type: Object, required: true}) readonly currentUser!:User;
    @Prop({type: String, default: "project"}) readonly size?: string;
    @Prop({type: String, default: undefined}) readonly buttonText?: string;
    dialog: boolean = false;

    toggle(): void {
      this.dialog = true;
    }

    get text(): string {
      if (!this.buttonText) {
        return "Create Group"
      }
      return this.buttonText
    }

    get noCompany(): boolean {
      return !this.companyId;
    }
  }
